define(() => {
    "use strict";

    return {

        // "channels_admin" (client site) -> "toolbar" (editor)
        PAGE_IS_CHANNELS_ENABLED:    "pageIsChannelsEnabled",
        PUBLISH_TO_CHANNEL:          "publishToChannel",
        CONTENT:                     "content",
        CREATE_CHANNEL_AND_PUBLISH:  "createChannelAndPublish",
        REMOVE_CURRENT_CONTENT:      "removeCurrentContent",
        REMOVE_SCHEDULED_CONTENT:    "removeScheduledContent",
        DELETE_CHANNEL:              "deleteChannel",
        SCHEDULED_DATE_CHANGED:      "scheduledDateChanged",
        WRONG_CONFIG_ID:             "wrongConfigId",
        WRONG_BOOKMARKLET:           "wrongBookmarklet",
        BROWSER_NOT_SUPPORTED:       "browserNotSupported",
        SET_FLAGS:                   "setFlags",

        // "toolbar" (editor) -> "channels_admin" (client site) or vise versa in certain cases
        INITIALIZE_CHANNELS: "initializeChannels",
        POPULATE_CHANNELS:    "populateChannels",
        SET_HIGHLIGHT:        "setHighlight",
        DRAG_START:           "dragStartMessage",
        DRAG_END:             "dragEndMessage",

        // "drop_page" (iframe with "src = dropPage.html" inserted in "channels_admin" page) -> "channels_admin"
        DRAG:       "dragMessage",
        DRAG_LEAVE: "dragLeaveMessage",
        DROP:       "dropMessage",

        NAVIGATE_TO:   "navigateTo",
        SUPPORT:       "support"
    };
});



// WEBPACK FOOTER //
// ./src/editor/ui/publish/MessageTypes.js